(function($) {
  'use strict';

  const doodles = {
    items: {},

    svgCount: 0,

    doodleElems: $('.doodle'),

    getDoodles: function() {
      const _ = this;

      let promises = [];
      const localDoodles = localStorage.getItem('doodles') ? JSON.parse(localStorage.getItem('doodles')) : false;
      const localDoodleCount = localDoodles ? Object.keys(localDoodles).length : 0;

      promises.push(_.getDoodleList());

      $.when.apply(null, promises).done(function() {
        const doodleCount = Object.keys(_.items).length;

        if (localDoodleCount === doodleCount) {
          _.items = localDoodles;
        }

        if (localDoodleCount !== doodleCount) {
          let promises2 = [];
          for (let doodle in _.items) {
            if (_.items[doodle] === undefined) {
              let request = _.getDoodle(doodle);
              promises2.push(request);
            }
          }

          $.when.apply(null, promises2).done(function() {
            localStorage.setItem('doodles', JSON.stringify(_.items));
            _.setDoodles();
          });
        }
        else {
          _.setDoodles();
        }
      });
    },

    getDoodleList: function() {
      const _ = this;
      return $.ajax({
        url: '/views/site/images/doodles/filelist.php',
        dataType: 'json',
        success: function(data) {
          for (let doodle in data) {
            if (data[doodle].length) {
              _.items[data[doodle]] = undefined;
            }
          }
        }
      });
    },

    getDoodle: function(doodle) {
      const _ = this;
      return $.ajax({
        url : '/views/site/images/doodles/' + doodle + '.svg',
        dataType: 'html',
        success: function(data) {
          // set mask stroke lengths for animation
          const $svg = $(data);
          const $defs = $svg.find('defs');
          const mask = $defs.find('mask');
          if (mask.length) {
            const masks = mask.children();
            masks.each(function(index, element) {
              var length = element.getTotalLength();
              element.style.strokeDasharray = length;
              element.style.strokeDashoffset = length;
            });
          }

          _.items[doodle] = new XMLSerializer().serializeToString($svg[0]);
        }
      });
    },

    setDoodles: function() {
      const _ = this;
      let promises = [];

      for (let doodle in _.items) {
        if (_.items[doodle] !== undefined) {
          $('.doodle.' + doodle).prepend(_.items[doodle]).addClass('loaded');
          promises.push($('.doodle.' + doodle));
        }
      }

      $.when.apply(null, promises).done(function() {
        _.doodleElems.each(function() {
          const $doodle = $(this).find('svg');
          const $mask = $doodle.find('mask');
          if ($mask.length) {
            $mask.attr('id', 'svg-mask-' + _.svgCount);
            $doodle.children('path').attr('mask', 'url(#svg-mask-' + _.svgCount + ')');
            _.svgCount++;
          }
        });

        _.showDoodles();

        $(window).on('scroll resize', function() {
          _.showDoodles();
        });
      });
    },

    showDoodles: function() {
      const _ = this;
      _.doodleElems.each(function(index, element) {
        const $this = $(this);
        if (inViewport(element)) {
          setTimeout(function() {
            $this.addClass('animate');
          }, 1000);
        }
      });
    },

    ready: function() {
      this.getDoodles();
    }
  };

  $(window).on('load', function() { doodles.ready(); });

})(jQuery);
